import { createContext } from 'react';

const WhatsNewContext = createContext(undefined);

export { WhatsNewContext };
